"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var AssetPortalActions = function AssetPortalActions(props) {
  var Actions = (0, _exchangeReactHooks.usePortalActions)();
  return /*#__PURE__*/_react.default.createElement(Actions, props);
};
var _default = exports.default = AssetPortalActions;
//# sourceMappingURL=AssetPortalActions.js.map